import React, { useCallback, useEffect, useMemo } from 'react';
import DocumentTitle from '../../shared/components/DocumentTitle';
import * as types from '../../store/constants';
import * as consts from '../../store/constants';
import { ACTION_DECREASE, ACTION_INCREASE, ACTION_SET, GROUPBY_BUNDLES } from '../../store/constants';
import { ListProduct, ProductMetaData, ProductSorting, UsageCondition } from '../../../models/Product';
import { SelectionList } from '../../../models/SelectionList';
import { getGroupItemId, GroupItem } from '../../../models/GroupItem';
import { Article, SubscriptionPeriodType } from '../../../models/Article';
import { useParams } from 'react-router';
import { invalidateSelectionListProducts, useSelectionListProducts } from './api/useSelectionListProducts';
import { LoadingWrapper } from '../../shared/components/LoadingWrapper';
import LoadingOverlay from '../../shared/components/LoadingOverlay';
import { SelectionListHeader } from './header/SelectionListHeader';
import FilterBar from '../../shared/common/FilterBar';
import GroupedByList from '../../shared/common/GroupedByList';
import GroupedByBundleItem from '../../shared/bundles/GroupedByBundleItem';
import SelectionlistProductTile from './SelectionlistProductTile';
import SelectionlistListItem from './SelectionlistListItem';
import NoElementsFound, { NO_ELEMENTS_PRODUCTS } from '../../shared/components/NoElementsFound';
import ProductList from '../../shared/common/ProductList';
import Pagination from '../../shared/common/Pagination';
import { SelectionListCommentsBar } from './SelectionListCommentsBar';
import { ContainerInnerWithColumns } from '../../shared/common/ContainerInner';
import { LIST_SORTING } from '../../shared/common/SortByDropDown';
import { useDownloadCSV } from '../../api/selection-list/useDownloadCSV';
import { useDownloadPdf } from '../../api/selection-list/useDownloadPdf';
import {
    invalidateSelectionListSummary,
    useSelectionListSummary
} from '../../api/selection-list/useSelectionListSummary';
import { useUpdateSelectionList } from './header/hooks/selectionListHooks';
import { ResponsiveFilterBar } from '../../shared/filter/ResponsiveFilterBar';
import { fetchSelectionListAggregationsQuickSearch } from '../../api/selection-list/fetchSelectionListAggregationsQuicksearch';
import {
    invalidateSelectionListGroupedItems,
    useSelectionListGroupedItems
} from '../../api/selection-list/useSelectionListGroupedItems';
import { useBulkChangeSubscriptionPeriod } from './useBulkChangeSubscriptionPeriod';
import { FetchAggregationsQuickSearch } from '../../api/listContent/fetchAggregationsQuickSearch';
import { useDefaultVisibleFilterGroups } from '../../shared/filter/defaultVisibleFilterGroups';
import { invalidateSelectionListAggregations, useSelectionListAggregations } from './useSelectionListAggregations';
import { useBulkUpdateUsageConditions } from '../../api/selection-list/bulkUpdateUsageConditions';
import { CommentsProvider } from './CommentsProvider';
import { useTranslation } from 'react-i18next';
import { useCopyBulkToSelectionList } from '../../api/selection-list/useCopyToList';
import { ListSourceType } from '../../../models/ListSourceType';
import { useCopyBulkToCart } from '../../api/shopping-cart/useCopyBulkToCart';
import { useMoveBulkToSelectionList } from '../../api/selection-list/useMoveToList';
import { useChangePriceInList } from '../../api/selection-list/useChangePriceInList';
import { useCopyBundleGroupToCart } from '../../api/shopping-cart/useCopyBundleGroupToCart';
import { useCopyBundleGroupToSelectionList } from '../../api/selection-list/useCopyBundleGroupToList';
import { useMoveBundleGroupToSelectionList } from '../../api/selection-list/useMoveBundleGroupToList';
import { useCopyToCart } from '../../api/shopping-cart/useCopyToCart';
import { useCopySingleToSelectionList } from '../../api/selection-list/useCopySingleToList';
import { useMoveSingleToSelectionList } from '../../api/selection-list/useMoveSingleToList';
import {
    isSingleCopyOptions,
    isSingleMoveOptions,
    SingleAddOptions,
    SingleCopyOrMoveOptions
} from '../../../models/ListContentCheckOptions';
import { ListActionTarget } from '../../../models/ListActionTarget';
import { useListContentChecks } from '../../shared/common/useListContentChecks';
import { CheckBeforeAddingModal } from '../../shared/common/CheckBeforeAddingModal';
import { useRemoveBulkFromSelectionList } from '../../api/selection-list/useRemoveFromList';
import { useChangeAmountSingleProductInList } from '../../api/selection-list/useChangeAmountSingleProductInList';
import { useChangeAmountBulkInList } from '../../api/selection-list/useChangeAmountBulkInList';
import { useRemoveSingleFromList } from '../../api/selection-list/useRemoveSingleFromList';
import { useAddProductsToGroupFromList } from '../../api/library-managed/addProductsToGroupFromList';
import { useChangeAmountGroupedItemInList } from '../../api/selection-list/useChangeAmountGroupedItemInList';
import { useRemoveGroupedItemFromList } from '../../api/selection-list/useRemoveGroupedItemFromList';
import { globalErrorResponse, TYPE_WARNING } from '../../shared/notification/actions';
import { log } from '../../shared/utils/log';
import { useIsAdmin } from '../../shared/utils';
import { useDuplicateListMutation } from '../../api/selection-list/useDuplicateListMutation';
import { MAX_SELECT, useProductSelection } from '../../shared/product-selection/useProductSelection';
import { hasProductSelection } from '../../shared/product-selection/ProductSelectionUtils';
import { ExcludeProductSelection } from '../../shared/product-selection/ProductSelectionTypes';
import { PriceTier } from '../../../models/PriceTier';
import { UnavailableProductsModal } from '../../shared/common/UnavailableProductsModal';
import { useDeleteSelectionList } from '../../api/selection-list/useDeleteSelectionList';
import { invalidateSelectionLists, useSelectionLists } from '../../api/selection-list/useSelectionLists';
import { useDisplayTypeSearchParam } from '../../shared/utils/useDisplayTypeSearchParam';
import { useDisplayFilterSearchParam } from '../../shared/utils/useDisplayFilterSearchParam';
import { showNotification } from '../../shared/notification/toastNotification';
import { usePaginationAndSortParams } from '../../shared/hooks/usePaginationAndSortParams';
import { useProductFilters } from '../../shared/filter/useProductFilters';
import isEmpty from 'lodash/isEmpty';
import { useNavigate } from 'react-router-dom';
import { useGroupBySearchParam } from '../../shared/common/useGroupBySearchParam';

export const SelectionListPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id = '' } = useParams<'id'>();
    const isAdmin = useIsAdmin();

    const { selectAll, toggleSelectionMode, productSelection, cancelSelection, onSelectButtonClick } =
        useProductSelection();

    const { parsedGrouping } = useGroupBySearchParam();

    const isGroupedBy = parsedGrouping.key !== types.GROUPBY_PRODUCTS;
    const isNotGroupExpanded = isGroupedBy && !parsedGrouping.id;

    const { displayFilter } = useDisplayFilterSearchParam();

    const { data: listSummary, isInitialLoading: isLoadingSummary, error } = useSelectionListSummary(id);
    const { activeList } = useSelectionLists();

    useEffect(() => {
        if (
            activeList?.id &&
            listSummary?.id &&
            activeList?.id === listSummary?.id &&
            activeList.lastModifiedAt !== listSummary?.lastModifiedAt
        ) {
            invalidateSelectionLists().then();
        }
    }, [activeList?.id, activeList?.lastModifiedAt, listSummary?.id, listSummary?.lastModifiedAt]);

    useEffect(() => {
        if (error) {
            globalErrorResponse(error);
            if (error.response?.status === 404) {
                navigate(consts.PATH_CATALOGUE);
                invalidateSelectionLists().then();
            } else {
                log.error(error.message);
            }
        }
    }, [error, navigate]);

    const { productFilter } = useProductFilters();

    const { page, pageSize, sortBy } = usePaginationAndSortParams({
        defaultSortBy: ProductSorting.RELEASE_DATE_NEW_TO_OLD,
        defaultPageSize: 54
    });

    const { display } = useDisplayTypeSearchParam();

    const { products, isLoading: isSelectionListProductsIsLoading } = useSelectionListProducts({
        filterMap: productFilter,
        pagination: { sortBy, page, pageSize },
        listId: id,
        groupType: parsedGrouping.key,
        groupId: parsedGrouping.id
    });

    const { data: groupedItems, isInitialLoading: isGroupedItemsLoading } = useSelectionListGroupedItems({
        listId: id,
        enabled: isGroupedBy
    });

    const defaultVisibleFilterGroups = useDefaultVisibleFilterGroups();

    //region FILTERBAR_V2
    const visibleFilterGroups = useMemo(
        () => [...defaultVisibleFilterGroups, 'selectedLendingModel', 'selectedUsageCondition', 'selectedPrice'],
        [defaultVisibleFilterGroups]
    );
    const { aggregationsQueryKeyBuilder, fetchAggregations } = useSelectionListAggregations(id, parsedGrouping);
    const fetchAggregationsQuickSearchCallback = useCallback<FetchAggregationsQuickSearch>(
        options => fetchSelectionListAggregationsQuickSearch({ ...options, listId: id }),
        [id]
    );
    //endregion

    const { mutate: updateSelectionListName, isLoading: isLoadingSelectionListName } = useUpdateSelectionList(id);

    const bulkChangeSubscriptionPeriodMutation = useBulkChangeSubscriptionPeriod(id, productSelection, productFilter);

    const { mutate: downloadCSV, isLoading: isDownloadingCSV } = useDownloadCSV({
        id,
        name: listSummary?.listName ?? 'selectionList'
    });
    const { mutate: downloadPdf, isLoading: isDownloadingPDF } = useDownloadPdf({
        id,
        name: listSummary?.listName ?? 'selectionList'
    });

    const { copyToListBulk: copyBulkProductsToList } = useCopyBulkToSelectionList({
        filter: productFilter,
        source: ListSourceType.SELECTION_LIST,
        sourceSelectionListId: id,
        productSelection
    });

    const { isLoading: isLoadingMoveToList, moveToListBulk: moveBulkProductsToList } = useMoveBulkToSelectionList({
        source: ListSourceType.SELECTION_LIST,
        sourceSelectionListId: id,
        onSuccess: cancelSelection,
        productSelection,
        productFilter
    });

    const { copyToCartBulk: copyBulkProductsToCart } = useCopyBulkToCart({
        sourceSelectionListId: id,
        onSuccess: () => {
            invalidateSelectionListProducts(id).then();
        },
        productFilter
    });

    const { isLoading: isLoadingDuplicateList, mutate: duplicateList } = useDuplicateListMutation({
        sourceListId: id
    });

    const onBulkCopyToList = (targetList: SelectionList, performChecks: boolean) => {
        return copyBulkProductsToList(targetList.id, performChecks);
    };

    const onBulkMoveToList = (targetList: SelectionList, performChecks: boolean) => {
        return moveBulkProductsToList(targetList.id, performChecks).then(data => {
            if (!performChecks) {
                invalidateSelectionLists().then();
            }
            return data;
        });
    };

    const { addToCart: copyToCart } = useCopyToCart({
        sourceListId: id,
        callback: () => invalidateSelectionListProducts(id).then()
    });

    const { copyToList } = useCopySingleToSelectionList({
        source: ListSourceType.SELECTION_LIST,
        sourceSelectionListId: id
    });

    const { moveToList } = useMoveSingleToSelectionList({
        source: ListSourceType.SELECTION_LIST,
        sourceSelectionListId: id
    });

    const { isLoading: isLoadingChangeAmountsingle, changeAmount } = useChangeAmountSingleProductInList({
        listId: id
    });

    const onAction = useCallback(
        (performChecks: boolean, options: SingleAddOptions | SingleCopyOrMoveOptions) => {
            if (isSingleCopyOptions(options) && options.target === ListActionTarget.List) {
                return copyToList(options.options, options.listId, performChecks);
            } else if (isSingleMoveOptions(options) && options.target === ListActionTarget.List) {
                return moveToList(options.options, options.listId, performChecks);
            } else {
                return copyToCart(options.options, performChecks);
            }
        },
        [copyToCart, copyToList, moveToList]
    );

    const { changePrice, getCheckBeforeAddingModalProps, getUnavailableProductsModalProps } = useListContentChecks<
        SingleAddOptions | SingleCopyOrMoveOptions
    >({ onAction });

    const { changePriceBulk } = useChangePriceInList(productFilter);

    const { copyToCartBulk: copyBundleGroupToCart } = useCopyBundleGroupToCart({
        onSuccess: () => {
            invalidateSelectionListProducts(id).then();
        }
    });

    const { isLoading: isLoadingRemoveSingle, mutateAsync: removeSingleFromList } = useRemoveSingleFromList(id);

    function onCopyGroupToCart(bundleId: string, performChecks: boolean) {
        return copyBundleGroupToCart(id, bundleId, performChecks);
    }

    const { isLoading: isLoadingRemoveFromList, removeBulkFromList } = useRemoveBulkFromSelectionList({
        onSuccess: cancelSelection,
        productSelection,
        productFilter
    });

    function onRemoveBulkFromList() {
        removeBulkFromList(id).then(() => {
            invalidateSelectionListProducts(id).then();
            invalidateSelectionListAggregations(id).then();
            invalidateSelectionListSummary(id).then();
            invalidateSelectionListGroupedItems(id).then();
            if (listSummary) {
                invalidateSelectionLists().then();
            }
        });
    }

    const { changeAmountBulk } = useChangeAmountBulkInList({
        listId: id,
        productSelection,
        productFilter
    });

    function onCopyAmountChangeBulk(
        amount: number,
        command: typeof ACTION_SET | typeof ACTION_INCREASE | typeof ACTION_DECREASE = ACTION_SET
    ) {
        return changeAmountBulk(amount, command, () => {
            if (listSummary) {
                invalidateSelectionLists().then();
            }
        });
    }

    const { removeGroupedItem } = useRemoveGroupedItemFromList({
        listId: id
    });

    async function onRemoveGroupedItemFromList(item: GroupItem) {
        const group = { ...parsedGrouping, id: getGroupItemId(item) };
        await removeGroupedItem(group);
    }

    const { copyToListBulk: copyBundleGroupToList } = useCopyBundleGroupToSelectionList({
        source: ListSourceType.SELECTION_LIST,
        sourceSelectionListId: id
    });

    function onCopyBundleGroupToList(item: GroupItem, list: SelectionList, performChecks: boolean) {
        return copyBundleGroupToList(getGroupItemId(item), list.id, performChecks);
    }

    const { isLoading: isLoadingMoveGroupToList, moveToListBulk: moveBundleGroupToList } =
        useMoveBundleGroupToSelectionList({
            source: ListSourceType.SELECTION_LIST,
            sourceSelectionListId: id
        });

    function onMoveBundleGroupToList(item: GroupItem, list: SelectionList, performChecks: boolean) {
        return moveBundleGroupToList(getGroupItemId(item), list.id, performChecks);
    }

    const { changeAmountGroupedItem } = useChangeAmountGroupedItemInList({
        listId: id
    });

    function onGroupAmountChange(
        item: GroupItem,
        amount: number,
        command: typeof ACTION_SET | typeof ACTION_INCREASE | typeof ACTION_DECREASE
    ) {
        const group = { ...parsedGrouping, id: getGroupItemId(item) };
        return changeAmountGroupedItem(group, amount, command);
    }

    const addListToCartAll = (performChecks: boolean) => {
        const productSelection: ExcludeProductSelection = {
            excluded: [],
            totalCount: products.count
        };

        if (productSelection.totalCount > MAX_SELECT) {
            showNotification(t('notifications.useProductSelection.error', { maxSelect: MAX_SELECT }), TYPE_WARNING);
            throw new Error('max selection exceeded');
        }

        return copyBulkProductsToCart(performChecks, productSelection);
    };

    const onChangePriceAll = (priceTier: PriceTier, performChecks: boolean) => {
        const productSelection: ExcludeProductSelection = {
            excluded: [],
            totalCount: products.count
        };

        if (productSelection.totalCount > MAX_SELECT) {
            showNotification(t('notifications.useProductSelection.error', { maxSelect: MAX_SELECT }), TYPE_WARNING);
            throw new Error('max selection exceeded');
        }

        return changePriceBulk(priceTier, id, performChecks, productSelection);
    };

    const bulkUpdateUsageConditions = useBulkUpdateUsageConditions(id);

    async function onUpdateUsageCondition(
        product: ProductMetaData & Article,
        usageCondition: UsageCondition,
        subscriptionPeriodType: SubscriptionPeriodType | undefined = undefined
    ) {
        const sourceUsageCondition = product.price
            ? {
                  lendingModel: product.price.lendingModel,
                  usageLimit: product.price.usageLimit,
                  termLimit: product.price.termLimit
              }
            : {};
        const sourceSubscriptionPeriodType = product?.subscriptionPeriod?.type;
        const targetSubscriptionPeriodType = subscriptionPeriodType ?? product?.subscriptionPeriod?.type;

        await bulkUpdateUsageConditions([
            {
                productId: product.id,
                sourceUsageCondition: sourceUsageCondition,
                targetUsageCondition: usageCondition,
                sourceSubscriptionPeriodType,
                targetSubscriptionPeriodType
            }
        ]);
    }

    const { mutate: deleteSelectionList } = useDeleteSelectionList(id);

    const addProductsToGroupFromList = useAddProductsToGroupFromList({
        sourceListId: id,
        productSelection,
        onSuccess: () => {
            cancelSelection();
        },
        bundleRef: parsedGrouping.key === GROUPBY_BUNDLES && parsedGrouping.id ? parsedGrouping.id : undefined,
        productFilter
    });

    const loading =
        isSelectionListProductsIsLoading ||
        isLoadingSummary ||
        isLoadingSelectionListName ||
        isGroupedItemsLoading ||
        isDownloadingCSV ||
        isDownloadingPDF ||
        isLoadingMoveToList ||
        isLoadingMoveGroupToList ||
        isLoadingRemoveFromList ||
        isLoadingRemoveSingle ||
        isLoadingChangeAmountsingle ||
        isLoadingDuplicateList;

    return (
        <CommentsProvider>
            <DocumentTitle title={t('components.documentTitle.selectionlists')} />
            {id ? (
                <ContainerInnerWithColumns isLoading={loading}>
                    {loading ? (
                        <LoadingWrapper>
                            <LoadingOverlay loading={loading} />
                        </LoadingWrapper>
                    ) : null}
                    <>
                        <SelectionListHeader
                            isAdmin={isAdmin}
                            isInSelectionMode={hasProductSelection(productSelection)}
                            selectionList={listSummary || {}}
                            productSelection={productSelection}
                            copyListToCart={addListToCartAll}
                            cancelSelection={cancelSelection}
                            onBulkCopyToCart={performChecks => copyBulkProductsToCart(performChecks, productSelection)}
                            onBulkAddToGroup={addProductsToGroupFromList}
                            onCopyAmountChange={onCopyAmountChangeBulk}
                            onChangePrice={(priceTier, performChecks) =>
                                changePriceBulk(priceTier, id, performChecks, productSelection)
                            }
                            onCopyToList={onBulkCopyToList}
                            onMoveToList={onBulkMoveToList}
                            onRemoveFromList={onRemoveBulkFromList}
                            onDownloadCSV={downloadCSV}
                            onDownloadPdf={downloadPdf}
                            onDuplicateList={duplicateList}
                            onDelete={deleteSelectionList}
                            onSaveSelectionlistName={updateSelectionListName}
                            bulkChangeSubscriptionPeriodMutation={bulkChangeSubscriptionPeriodMutation}
                            hasActiveFilter={!isEmpty(productFilter)}
                            productsCount={products.count}
                        />
                        <FilterBar
                            sortBy={sortBy}
                            toggleSelectionMode={toggleSelectionMode}
                            selectAll={() => selectAll(products.count)}
                            displayType={display}
                            hidePagination={isGroupedBy}
                            hideSelectButtons={isNotGroupExpanded}
                            hideSelectAll={isGroupedBy}
                            totalProducts={products.count}
                            grouping={parsedGrouping}
                            onChangePrice={onChangePriceAll}
                            sorting={LIST_SORTING}
                            pageSize={pageSize}
                            productSelection={productSelection}
                        />
                    </>
                    <div className="flex-ca" style={{ alignItems: 'flex-start' }}>
                        {displayFilter ? (
                            <ResponsiveFilterBar
                                visibleFilterGroups={visibleFilterGroups}
                                buildQueryKey={aggregationsQueryKeyBuilder}
                                fetchAggregations={fetchAggregations}
                                fetchAggregationsQuickSearch={fetchAggregationsQuickSearchCallback}
                            />
                        ) : null}

                        <div className="ca-main">
                            {isGroupedBy ? (
                                groupedItems && groupedItems.length > 0 ? (
                                    <div className="ca-main-inner groupby-sl" key={`${parsedGrouping.key}_group`}>
                                        <GroupedByList
                                            currentPage={page}
                                            pageSize={pageSize}
                                            totalProducts={products.count}
                                            products={products?.list as ListProduct[]}
                                            productSelection={productSelection}
                                            displayType={display}
                                            groups={groupedItems as unknown as ReadonlyArray<GroupItem>}
                                            onSelectProduct={onSelectButtonClick}
                                            isGroupAddAction={true}
                                            itemComponent={GroupedByBundleItem}
                                            grouping={parsedGrouping}
                                            onAddPrice={changePrice}
                                            cancelProductSelection={cancelSelection}
                                            onMoveGroupToList={onMoveBundleGroupToList}
                                            onGroupAmountChange={onGroupAmountChange}
                                            onRemoveGroupedItemFromList={onRemoveGroupedItemFromList}
                                            onCopyGroupToList={onCopyBundleGroupToList}
                                            onCopyGroupedItemToCart={onCopyGroupToCart}
                                            invalidateAggregations={() => invalidateSelectionListAggregations(id)}
                                            isProductSelectable={true}
                                        >
                                            {({ key, isListView, ...value }) =>
                                                isListView ? (
                                                    <SelectionlistListItem
                                                        {...value}
                                                        key={key}
                                                        currentListId={id}
                                                        onRemoveProductFromList={() =>
                                                            removeSingleFromList(value.product)
                                                        }
                                                        onCopyAmountChange={(amount, command) =>
                                                            changeAmount(value.product, amount, command)
                                                        }
                                                        onUpdateUsageCondition={(
                                                            newUsageCondition,
                                                            newSubscriptionPeriodType
                                                        ) =>
                                                            onUpdateUsageCondition(
                                                                value.product,
                                                                newUsageCondition,
                                                                newSubscriptionPeriodType
                                                            )
                                                        }
                                                    />
                                                ) : (
                                                    <SelectionlistProductTile
                                                        {...value}
                                                        key={key}
                                                        currentListId={id}
                                                        onRemoveProductFromList={() =>
                                                            removeSingleFromList(value.product)
                                                        }
                                                        onCopyAmountChange={(amount, command) =>
                                                            changeAmount(value.product, amount, command)
                                                        }
                                                        onUpdateUsageCondition={(
                                                            newUsageCondition,
                                                            newSubscriptionPeriodType
                                                        ) =>
                                                            onUpdateUsageCondition(
                                                                value.product,
                                                                newUsageCondition,
                                                                newSubscriptionPeriodType
                                                            )
                                                        }
                                                    />
                                                )
                                            }
                                        </GroupedByList>
                                    </div>
                                ) : !loading ? (
                                    <NoElementsFound type={NO_ELEMENTS_PRODUCTS} />
                                ) : null
                            ) : null}

                            {!isGroupedBy ? (
                                products.count > 0 ? (
                                    <div className="ca-main-inner">
                                        <ProductList
                                            displayType={display}
                                            onSelectProduct={onSelectButtonClick}
                                            products={products.list}
                                            productSelection={productSelection}
                                            onAddPrice={changePrice}
                                            isProductSelectable={true}
                                        >
                                            {({ key, isListView, ...value }) =>
                                                isListView ? (
                                                    <SelectionlistListItem
                                                        {...value}
                                                        key={key}
                                                        currentListId={id}
                                                        onRemoveProductFromList={() =>
                                                            removeSingleFromList(value.product)
                                                        }
                                                        onCopyAmountChange={(amount, command) =>
                                                            changeAmount(value.product, amount, command)
                                                        }
                                                        onUpdateUsageCondition={(
                                                            newUsageCondition,
                                                            newSubscriptionPeriodType
                                                        ) =>
                                                            onUpdateUsageCondition(
                                                                value.product,
                                                                newUsageCondition,
                                                                newSubscriptionPeriodType
                                                            )
                                                        }
                                                    />
                                                ) : (
                                                    <SelectionlistProductTile
                                                        {...value}
                                                        key={key}
                                                        currentListId={id}
                                                        onRemoveProductFromList={() =>
                                                            removeSingleFromList(value.product)
                                                        }
                                                        onCopyAmountChange={(amount, command) =>
                                                            changeAmount(value.product, amount, command)
                                                        }
                                                        onUpdateUsageCondition={(
                                                            newUsageCondition,
                                                            newSubscriptionPeriodType
                                                        ) =>
                                                            onUpdateUsageCondition(
                                                                value.product,
                                                                newUsageCondition,
                                                                newSubscriptionPeriodType
                                                            )
                                                        }
                                                    />
                                                )
                                            }
                                        </ProductList>
                                        <Pagination totalItems={products.count} pageSize={pageSize} />
                                    </div>
                                ) : !loading ? (
                                    <NoElementsFound type={NO_ELEMENTS_PRODUCTS} />
                                ) : null
                            ) : null}
                        </div>

                        <SelectionListCommentsBar selectionListId={id} />
                    </div>
                    <CheckBeforeAddingModal {...getCheckBeforeAddingModalProps()} />
                    <UnavailableProductsModal {...getUnavailableProductsModalProps()} />
                </ContainerInnerWithColumns>
            ) : null}
        </CommentsProvider>
    );
};
